const getBaseUrl = () => {
  const { hostname, protocol } = window.location;

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000/api/v1/';
  }

  // Staging / Production (same domain as frontend)
  return `${protocol}//${hostname}/api/v1/`;
};

export const API_CONFIG = {
  // Always use the direct URL to the backend
  
  BASE_URL: getBaseUrl(),
  ENDPOINTS: {
    REFRESH_TOKEN: 'auth/token/refresh',
    LOGIN: 'auth/login',
    LOGOUT: 'auth/logout',
    REGISTER: 'auth/register/',
    DECODE_INVITE: 'auth/decode-invite/',
    FORGOT_PASSWORD: 'auth/forgot-password',
    RESET_PASSWORD: 'auth/reset-password',
    USER_ROLES: 'user-roles',    
    SINGLE_EMAIL_VERIFY: 'email-verify/single',
    BULK_EMAIL_VERIFY: 'email-verify/bulk',
    EMAIL_VERIFY_RESULT: 'email-verify/get-result/',
    EMAIL_VERIFY_LIST: 'email-verify/list',
    EMAIL_VERIFY_BULK_RESULT: 'email-verify/download/',
    PROJECT_LIST: 'project/list',
    DOWNLOAD_PROJECT: 'project/download-project/',
    UPDATE_PROJECT_REQUEST: 'project/update-request/',
    NEW_DATA_REQUEST: 'request/data-requirement',
    DATA_ENRICHMENT_REQUEST: 'request/data-enrichment',
    REQUEST: 'request/request',
    UPDATE_LIST:'project/update-list',
    UPDATE_USER:'users/update',
    REFER_AND_EARN:'request/refer-and-earn',
    PROFILE_PICTURE_UPDATE:'profile/picture-update',
    PROFILE_PICTURE_REMOVE:'profile/picture-remove',
    FEEDBACK:'customer/feedback',
    GET_CREDIT:'credit/get',
    SUBMIT_CREDIT_REQUEST:'credit/request',
    DEBIT_CREDIT:'credit/debit',
    SUB_USERS_LIST: 'sub-users/',
    SUB_USERS_CREATE: 'sub-users/',
    SUB_USERS_ACTIVATE: 'sub-users/',
    SUB_USERS_DEACTIVATE: 'sub-users/',
    SUB_USERS_DELETE: 'sub-users/',
  },
};